import React from 'react';
import { Reveal } from './Reveal';
type Volume = {
  number: string;
  title: string;
  description: string;
  tags: string[];
  featured?: boolean;
};
const volumes: Volume[] = [{
  number: 'VOLUME 01',
  title: '🏃 Step Biomechanics & Platform Mastery™',
  description: 'Master the 45° Glute Protocol, platform setup, and safety fundamentals. The science-based foundation every professional step instructor needs. Protect your clients’ joints and teach with complete confidence. Illustrated, structured, and ready to print from day one.',
  tags: ['45° Protocol', 'Safety', 'Anatomy', 'Printable']
}, {
  number: 'VOLUME 02 — Most Used',
  title: '🎯 Step Choreography Drill Bank™',
  description: '50+ step sequences ready to teach immediately. Basic Step, V-Step, Over-the-Top, Repeater Knees, L-Step and more. Every sequence illustrated, cued, and print-ready. Your complete choreography library in one single volume.',
  tags: ['50+ Sequences', 'All Levels', 'Illustrated', 'Printable'],
  featured: true
}, {
  number: 'VOLUME 03',
  title: '🔥 Step Interval Programming & Fat Loss Protocols™',
  description: 'Engineer real fat-loss results your clients can see and feel. EPOC intervals, BPM charts, and RPE protocols for step training. Stop guessing intensity — start programming it with precision.',
  tags: ['EPOC', 'BPM Charts', 'Fat Loss', 'Printable']
}, {
  number: 'VOLUME 04',
  title: '💙 Low-Impact Step Adaptations™',
  description: 'Adapt every class for seniors, beginners, and clients with knee issues. Complete modification protocols for every body type. Never freeze in front of a client with limitations again. Inclusive step classes start here.',
  tags: ['Modifications', 'Seniors', 'Knee Protocols', 'Printable'],
  featured: true
}, {
  number: 'VOLUME 05',
  title: '🎵 Step Music Engineering & 32-Count Mastery™',
  description: 'Use music as a precision teaching tool in every step class. BPM charts, 32-count phrase maps, and music cue scripts included. Make every transition feel professional and effortless.',
  tags: ['32-Count', 'BPM Charts', 'Music Cues', 'Printable']
}, {
  number: 'VOLUME 06',
  title: '💼 The Step Instructor Business Blueprint™',
  description: 'Fill your classes, build your brand, and charge what you are worth. Stop being replaceable. Marketing, social media, and revenue systems included — built exclusively for serious step instructors.',
  tags: ['Business', 'Marketing', 'Social Media', 'Printable']
}];
export function Modules() {
  return <section className="w-full bg-surface px-4 py-20 sm:py-24" data-id="element-147" data-mp="2rlsxfixky4pq">
      <div className="mx-auto max-w-6xl" data-id="element-148" data-mp="2vnxqafg7exbb">
        <Reveal className="mx-auto max-w-3xl text-center" data-id="element-149" data-mp="2vmmlccb0vjim">
          <h2 className="font-display text-4xl font-extrabold tracking-tight text-ink sm:text-5xl" data-id="element-150" data-mp="3jd8ih8jhnjdu">
            🏃 6 Complete <span className="text-green-dark" data-id="element-151" data-mp="3o4qm64cwby2i">Professional Volumes</span>
          </h2>
          <p className="mt-5 text-slate" data-id="element-152" data-mp="1cozpninevdfn">
            Every level covered. Every situation solved. Everything ready to print and use in class today.
          </p>
        </Reveal>
        <div className="mt-10 grid gap-5 md:grid-cols-2" data-id="element-153" data-mp="1mfb624oa7f3f">
          {volumes.map((volume, index) => <Reveal key={volume.number} delay={index % 2 * 0.06} data-id="element-154" data-mp="1hghu4gon7w5d" data-mpi={index}>
              <article className={`flex h-full flex-col rounded-2xl border bg-mist p-8 shadow-premium ${volume.featured ? 'border-green' : 'border-ink/10'}`} data-id="element-155" data-mp="1hib15x364idw">
                <p className="text-xs font-bold uppercase tracking-[0.15em] text-teal" data-id="element-156" data-mp="otdi3rr4uhk3">{volume.number}</p>
                <h3 className="mt-4 font-display text-2xl font-bold leading-tight text-ink" data-id="element-157" data-mp="13mqhv0jj1y5y">{volume.title}</h3>
                <p className="mt-4 flex-1 text-sm leading-7 text-slate" data-id="element-158" data-mp="ys33vvm5gm5m">{volume.description}</p>
                <ul className="mt-6 flex flex-wrap gap-2" data-id="element-159" data-mp="2f5t955p09ggu">
                  {volume.tags.map(tag => <li key={tag} className="rounded-full bg-sky px-3 py-1.5 text-xs font-semibold text-ink" data-id="element-160" data-mp="2a78ahapej4ui">
                      {tag}
                    </li>)}
                </ul>
              </article>
            </Reveal>)}
        </div>
      </div>
    </section>;
}